import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
    Avatar,
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    LinearProgress,
    Divider,
    Typography,
    makeStyles
} from '@material-ui/core';
import MusicSnackbar from 'src/components/MusicSnackbar';
import MusicianContext from 'src/musicianContext';
import { firebase } from 'src/db/db';
const storageRef = firebase.storage().ref();

const useStyles = makeStyles(() => ({
    root: {},
    avatar: {
        height: 100,
        width: 100
    }
}));

const SongUploader = ({ className, updateMusicView, ...rest }, props) => {
    const classes = useStyles();
    const musician = useContext(MusicianContext);
    const [audioFile, setAudioFile] = useState();
    const [audioName, setAudioName] = useState();
    const [audioSrc, setAudioSrc] = useState();
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);

    const handleAudioChange = (e) => {
        const file = e.target.files[0];
        const url = URL.createObjectURL(file);

        //Update state.
        setAudioName(file.name);
        setAudioSrc(url);
        setAudioFile(file);
    };

    const selectAudioFile = () => {
        document.getElementById("upload").click();
    };

    const handleClearAudio = () => {
        setAudioSrc(null);
        setAudioFile(null);
        setAudioName(null);
        document.getElementById('upload').value = '';
    };

    const upload = () => {
        if (audioFile) {
            const uploadTask = storageRef.child("musicians/" + musician.musician + "/audio/" + audioName).put(audioFile)
            uploadTask.on('state_changed', // Progress function
                (snapshot) => {
                    const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                    setUploadProgress(progress);
                },
                // Error function
                (error) => { console.log('error', error) },
                async () => { // Complete function
                    await updateMusicView();
                    setUploadProgress(0);
                    setAudioFile(null);
                    setIsSnackbarOpen(true);
                }
            )
        }
    }

    return (
        <Card className={clsx(classes.root, className)} {...rest}>
            <CardContent>
                <Box alignItems="center" display="flex" flexDirection="column">
                    <Avatar className={classes.avatar} src={musician.logo} />
                    <Typography color="textPrimary" gutterBottom variant="h3">
                        Upload Music
                    </Typography>
                    {
                        audioName ?
                        <Typography className={classes.dateText} color="textSecondary" variant="body1">
                            {`Track Name: ${audioName}`}
                        </Typography> :
                        <Typography className={classes.dateText} color="textSecondary" variant="body1">
                            {`Artist Name: ${musician.musician ? musician.musician : "..."}`}
                        </Typography>
                    }
                    {
                        audioSrc ?
                        <Box mt={1}>
                            <audio id="player" src={audioSrc} controls />
                            <Box mt={1} alignItems="center" display="flex" flexDirection="column">
                                <Button color="primary" fullWidth variant="text" onClick={handleClearAudio}>
                                    Clear
                                </Button>
                            </Box>
                        </Box> : undefined
                    }
                </Box>
            </CardContent>

            <Divider />

            <CardActions>
                {
                    audioFile ?
                    <Button color="primary" fullWidth variant="contained" onClick={upload}>
                        Upload
                    </Button> :
                    <Button color="primary" fullWidth variant="text" onClick={selectAudioFile}>
                        Pick a Track
                    </Button>
                }
                <input id="upload" hidden style={{ opacity: 0 }} type="file" accept="audio/*" onChange={handleAudioChange} />
            </CardActions>
            <LinearProgress variant="determinate" value={uploadProgress} />

            <MusicSnackbar 
                text={`Success! Uploaded ${audioName}`}
                setOpen={setIsSnackbarOpen}
                open={isSnackbarOpen}
                severity="success"
            />
        </Card>
    );
};

SongUploader.propTypes = {
  className: PropTypes.string
};

export default SongUploader;
